module.exports = __webpack_public_path__ + "img/main_2.2668b5f0.webp";